// TemperatureSlider.jsx
import React from "react";
import { Box } from "@mui/material";

const NiceSlider = React.memo(
    ({
        value,
        onChange,
        minValue,
        maxValue,
        stepValue,
        labels = ["Stable", "Balanced", "Creative"],
        gradient = "linear-gradient(90deg, #3182CE 0%, #6B46C1 50%, #F56565 100%)",
    }) => {

       

     

        return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, pointerEvents: "none", }}>
                <Box sx={{ flex: 1 }}>
                    <Box
                        sx={{
                            position: "relative",
                            height: 26,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        {/* TŁO PASKA */}
                        <Box
                            sx={{
                                position: "absolute",
                                inset: 6,
                                borderRadius: 999,
                                background:
                                    "linear-gradient(90deg, #3182CE 0%, #6B46C1 50%, #F56565 100%)",
                                opacity: 0.4,
                                pointerEvents: "none",
                            }}
                        />

                        {/* RANGE INPUT */}
                        <input
                            type="range"
                            min={minValue}
                            max={maxValue}
                            step={stepValue}
                            value={value}
                            onChange={(e) => {
                                onChange(e);
                            }}
                            style={{
                                position: "relative",
                                width: "100%",
                                WebkitAppearance: "none",
                                background: "transparent",
                                outline: "none",
                                height: 26,
                                cursor: "pointer",
                                pointerEvents: "auto",
                            }}
                        />

                        {/* STYL GAŁKI (WEBKIT) */}
                        <style>
                            {`
              input[type="range"]::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                width: 18px;
                height: 18px;
                border-radius: 999px;
                background: white;
                border: 2px solid #6B46C1;
                box-shadow: 0 0 6px rgba(0,0,0,0.35);
                margin-top: -4px;
              }
              input[type="range"]::-moz-range-thumb {
                width: 18px;
                height: 18px;
                border-radius: 999px;
                background: white;
                border: 2px solid #6B46C1;
                box-shadow: 0 0 6px rgba(0,0,0,0.35);
              }
              input[type="range"]::-webkit-slider-runnable-track {
                height: 6px;
                border-radius: 999px;
                background: transparent;
              }
              input[type="range"]::-moz-range-track {
                height: 6px;
                border-radius: 999px;
                background: transparent;
              }
            `}
                        </style>
                    </Box>

                    {/* Podpis pod suwakiem */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mt: 0.5,
                            fontSize: 11,
                            opacity: 0.8,
                        }}
                    >
                        <span>{labels[0]}</span>
                        <span>{labels[1]}</span>
                        <span>{labels[2]}</span>
                    </Box>
                </Box>

                {/* WARTOŚĆ LICZBOWA */}
                <Box
                    sx={{
                        minWidth: 60,
                        textAlign: "right",
                        fontSize: 13,
                        fontWeight: 500,
                    }}
                >
                    {value}
                </Box>
            </Box>        );
    }
);

export default NiceSlider;
